const Promise = require('bluebird')
const Vue = require('vue')

const { client } = require('sci/helpers')

module.exports = () => new Promise((resolve, reject) => {
    Vue.component('properties_raised', {
        template: `
            <div class="grid-item col-xs-12 col-sm-6 col-md-6 col-lg-3">
                <div class="dashboard-widget-novos-imoveis">
                    <div class="display">
                        <div class="number">
                            <h3 class="font-blue-sharp">
                                <span data-counter="counterup" data-value="7800">{{data.info.count}}</span>
                                <small class="font-blue-sharp" style="font-size:12px;">novos imóveis</small>
                            </h3>
                            <small>novos cadastros</small>
                            <!--
                            <button class="btn btn-xs green-jungle" style="margin-top: -4px" :disabled="refreshing" @click="refresh()">
                                atualizar
                            </button>
                            -->
                        </div>
                        <div class="icon">
                            <i class="icon-pie-chart"></i>
                        </div>
                    </div>
          
                    <div v-if="refreshing" class="text-center" style="padding: 40px">
                        Carregando...
                    </div>
                    <div v-if="!refreshing">
                        <div v-slimscroll :height="240" :always="true">
                            <table class="table table-light table-condensed table-striped table-hover">
                                <tbody>
                                    
                                    <tr v-for="item in data.info.list">	
                                        <!--<td><span class="label label-warning label-sm">6 <i style="font-size:11px;" class="glyphicon glyphicon-fire"></span></i></td>-->
                                        <td>
                                            <span class="label label-warning label-sm"
                                                    style="margin-right: 4px;
                                                    cursor: pointer"
                                                    v-if="!!item.interested_customers_count"
                                                    v-property-info
                                                    :id="item.id"
                                                    tab="forms">
                                                <i class="glyphicon glyphicon-fire" style="font-size: 11px"></i>
                                                {{ item.my_interested_customers_count }}
                                            </span>
                                            <span class="label label-default label-sm" style="margin-right: 4px" v-if="!item.interested_customers_count">
                                                <i class="glyphicon glyphicon-fire" style="font-size: 11px"></i>
                                                0
                                            </span>
                                            {{item.typeInfo.name}}
                                        </td>
                                        <td class="visible-lg"><span class="">{{item.roomsCount.dorm}} <i class="fa fa-bed" style="font-size:12px;"></i></span></td>
                                        <td>{{item.user.name | firstName}}</td>
                                        <td>
                                            <button class="btn btn-default btn-xs" v-property-info :id="item.id" :circling="ids"><i class="fa fa-eye"></i></button>
                                        </td>
                                    </tr>

                                    
                                </tbody>
                            </table>
                        </div>	
                    </div>
                </div>

            </div>
        `,
        props: ['alias', 'data'],
        data: () => ({
            refreshing: false
        }),
        computed: {
            ids() {
                return this.data.info.list.map(i => i.id );
            }
        },
        methods: {
            refresh () {
                this.refreshing = true
                client
                    .post('Atualizando...', 'utils/update-properties-interested-customers')
                    .then(() => {
                        client
                            .get('Atualizando...', 'widgets/dashboard/default?force=true')
                            .then(({ data }) => {
                                this.data = data.properties_raised
                                this.refreshing = false
                            })
                    })
            }
        }
    })

    resolve()
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/widgets/properties_raised.js